// src/components/Testimonials.js

import React from 'react';

// Imports des styles du carrousel
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

import Slider from 'react-slick';
import { BsStarFill, BsCheckCircleFill, BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import { FcGoogle } from 'react-icons/fc';

// --- C'EST ICI QUE NOUS AJOUTONS LES NOUVEAUX AVIS ---
const reviewsData = [
    {
        name: "lapesca974",
        date: "2025-09-09",
        rating: 5,
        isVerified: true,
        text: "Intervention rigoureuse et rapide de cet électricien. Suite à une panne d'alimentation de la plaque de cuisson, ce professionnel est intervenu le jour même et a réussi à trouver l'origine du problème, nous évitant ainsi des frais importants. Nous recommandons vivement ce professionnel sérieux et compétent.",
        initial: "L"
    },
    {
        name: "Camille",
        date: "2025-06-07",
        rating: 5,
        isVerified: true,
        text: "Personnel d’une humanité et gentillesse incroyable Coupure chez mes grands parents, ces derniers en stress car mon grand père malade a besoin de son lit médicalisé. Aucune aide d’EDF, impossibilité de trouver un électricien disponible (pas avant 3/4jours). Je ne sais pas qui j’ai eu au téléphone mais TechniService nous a été d’une grande aide. Ce monsieur, en 5 min a pu nous aider à retrouver l’électricité. J’ai noté votre numéro dans le répertoire de mes grands-parents (sur que cette entreprise ne se servira pas de leur vulnérabilité). Merci encore ! C’est comme ça que les gens se rappellent de vous.",
        initial: "C"
    },
    {
        name: "Evelyne",
        date: "2025-04-14",
        rating: 5,
        isVerified: true,
        text: "Mr Wolfersperger est non seulement un artisan rigoureux, pertinent et extrêmement méthodique, mais il possède une qualité très rare dans ce milieu professionnel, la réactivité. Il a toute ma gratitude pour l’excellent travail qu’il a réalisé chez moi, au niveau de mon tableau électrique.",
        initial: "E"
    },
    {
        name: "Pascal",
        date: "2025-03-29",
        rating: 5,
        isVerified: true,
        text: "Techni services (Jean-Christophe WOLFERSPERGER) a réalisé un dépannage suivi d'une mise aux normes de mon vieux tableau électrique (pose de quatre interrupteurs différentiels et de disjoncteurs). Il a fait preuve de réactivité et de professionnalisme sans faille. Il possède un appareillage de mesure électrique performant et sait s'en servir. D'un contact facile, toujours à l'écoute du client, il possède de solides bases sur les normes électriques et réalise un travail de qualité, tant dans la réalisation des câblages, la pose des accessoires, des goulottes et des appareillages. Pour résumer, il a rapidement trouvé des solutions, faisant preuve de minutie, d'un goût du travail bien fait et du respect des règles de sécurité. Je le conseille vivement !",
        initial: "P"
    },
    {
        name: "Lidwine",
        date: "2024-09-12",
        rating: 5,
        isVerified: true,
        text: "Artisan très créatif avec beaucoup d'idées. Il a des compétences dans de nombreux domaines. Cet artisan m'a accompagnée dans toute la rénovation de mon appartement et a créé de magnifiques objets en bois. Je recommande fortement cet artisan talentueux.",
        initial: "L"
    },
    {
        name: "Stephane",
        date: "2024-04-06",
        rating: 4,
        isVerified: true,
        text: "Intervention de qualité, pro et sympa",
        initial: "S"
    },
    {
        name: "Guillemette",
        date: "2023-06-15",
        rating: 5,
        isVerified: true,
        text: "Très disponible, très aimable, très efficace.",
        initial: "G"
    }
];
// --------------------------------------------------------

const PrevArrow = ({ className, style, onClick }) => <div className={className} style={style} onClick={onClick}><BsChevronLeft /></div>;
const NextArrow = ({ className, style, onClick }) => <div className={className} style={style} onClick={onClick}><BsChevronRight /></div>;

const Testimonials = () => {
    const settings = {
        dots: false, infinite: true, speed: 500, slidesToShow: 1, slidesToScroll: 1,
        autoplay: true, autoplaySpeed: 5000, pauseOnHover: true,
        prevArrow: <PrevArrow />, nextArrow: <NextArrow />
    };

    return (
        <section id="testimonials" className="testimonials-section">
            <div className="testimonial-layout">
                <div className="testimonial-intro">
                    <h4>Témoignages</h4>
                    <h2>Mes clients sont mes meilleurs ambassadeurs</h2>
                    <p>Pour preuve, retrouvez tous mes avis clients directement sur ma fiche Google.</p>
                    <a href="https://www.google.com/search?q=TechniServices+Avis" target="_blank" rel="noopener noreferrer" className="google-reviews-link">
                        Voir tous les avis
                    </a>
                </div>
                <div className="testimonial-slider-container">
                    <Slider {...settings}>
                        {reviewsData.map((review, index) => (
                            <div key={index}>
                                <div className="review-card">
                                    <div className="card-header">
                                        <div className="card-initials">{review.initial}</div>
                                        <div className="card-user-info"><strong>{review.name}</strong><span>{review.date}</span></div>
                                        <div className="card-google-logo"><FcGoogle /></div>
                                    </div>
                                    <div className="card-rating">
                                        {[...Array(review.rating)].map((_, i) => <BsStarFill key={i} />)}
                                        {review.isVerified && <BsCheckCircleFill className="verified-icon" />}
                                    </div>
                                    <p className="card-body">{review.text}</p>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </section>
    );
};

export default Testimonials;